import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { IonicModule } from '@ionic/angular';

import { LoginPageRoutingModule } from './login-routing.module';
import { LoginPage } from './login.page';
import * as fromLoginStore from './store';
import * as fromServices from './services';
import { SharedModule } from '../shared/shared.module';
import { UserModule } from '../user/user.module';
import { TranslateModule } from '@ngx-translate/core';
import { TraceHelperService } from '../shared/helpers/trace.helpers';
import { LoginAnalyticsService } from './analytics/login-analytics.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SharedModule,
    LoginPageRoutingModule,
    EffectsModule.forFeature([
      fromLoginStore.LoginEffects,
      fromLoginStore.RefreshAuthTokenEffects,
      fromLoginStore.OrderControlEffects,
    ]),
    UserModule,
    TranslateModule,
  ],
  declarations: [LoginPage],
  providers: [
    ...fromServices.services,
    {
      provide: 'refreshAuthTokenPaddingTimeSeconds',
      useValue: 60,
    },
    TraceHelperService,
    LoginAnalyticsService,
  ],
})
export class LoginPageModule {}
